export const inspect = val => `${val}`;
